import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';
import { jitteredStaleTime } from '~/utils/jitter';

import { getTriggerFilters, getTriggerOptions } from '../services/new-run.service';

/** Key segment for the unfiltered trigger-options read (every connector at once). */
const ALL_CONNECTORS = '';

/**
 * Every connector's New Run options plus the active flows, in one read — feeds the
 * connector cards, the flow override and the run list's connector / flow filters.
 * The vocabulary only changes on a deploy, so it stays fresh for the session.
 */
export function useNewRunOptions() {
  return useQuery({
    queryKey: queryKeys.catalogService.triggerOptions(ALL_CONNECTORS),
    queryFn: () => getTriggerOptions(),
    staleTime: Infinity,
  });
}

/** One connector's trigger filter vocabulary and this tenant's stored values for it. */
export function useNewRunFilters(connectorCode: string) {
  return useQuery({
    queryKey: queryKeys.catalogService.triggerFilters(connectorCode),
    queryFn: () => getTriggerFilters(connectorCode),
    enabled: !!connectorCode,
    staleTime: jitteredStaleTime(5 * 60 * 1000),
  });
}
